import { type StatsigLayerName, useLayer } from '@coursera-web/statsig';

const LAYER_NAME: StatsigLayerName = 's12n-free-trial-removal-india-layer';
const PARAM_NAME = 'remove-s12n-free-trial';

/**
 * True when the user is bucketed into the India free-trial-removal treatment arm.
 *
 * Reading the layer logs the Statsig exposure, so calling this hook wherever the treatment is
 * consumed (enroll CTA, enroll modal) doubles as the impression — no separate logging step.
 */
export const useFreeTrialRemovalTreatment = (): boolean => useLayer(LAYER_NAME).get(PARAM_NAME, false);
